import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { logMeal } from "features/meal/mealSlice"
import { MealType } from "model/food/types"
import getMealPayloadFromMeal from "model/food/utils/getPayloads/getMealPayloadFromMeal"

export const useLogMealFromMeal = (callback?: () => void) => {
  const logMealLoading = useAppSelector((state) => state.meal.logMealLoading)
  const logMealFailed = useAppSelector((state) => state.meal.logMealFailed)
  const logMealSuccess = useAppSelector((state) => state.meal.logMealSuccess)

  const dispatch = useAppDispatch()

  const handleLogMealFromMeal = (meal: MealType) => {
    let mealPayload = getMealPayloadFromMeal(meal)
    mealPayload.isManualNutrition = meal.isManualNutrition ?? false
    
    if (mealPayload) {
      dispatch(logMeal(mealPayload))
    }
  }

  useFailed(logMealFailed)
  useSuccess(logMealSuccess, { message: "" }, callback)

  return {
    logMealLoading,
    handleLogMealFromMeal,
  }
}

export default useLogMealFromMeal
